/* eslint no-shadow: ["error", { "allow": ["state"] }] */
// import axios from 'axios';
import _ from 'lodash';
import { setAxiosDefaultBaseURL } from '@/modules/axios/config';

const state = {
	isLoading: false,
	currentUser: {},
};

const getters = {
	isLoading: state => state.isLoading,
	currentUser: state => state.currentUser,
};

const mutations = {
	setIsCurrentUserLoading(state, isLoading) {
		state.isLoading = isLoading;
	},
	setCurrentUser(state, currentUser) {
		state.currentUser = _.cloneDeep(currentUser);
	},
	destoryCurrentUser(state) {
		state.currentUser = {};
	},
};

const actions = {
	setCurrentUser({ commit }, currentUser) {
		// set axios header;
		setAxiosDefaultBaseURL(currentUser);

		commit('setCurrentUser', currentUser);
		commit('setIsCurrentUserLoading', false);
	},
	destoryCurrentUser({ commit }) {
		commit('destoryCurrentUser');
	},
};

export default {
	state,
	getters,
	actions,
	mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js